module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"switch-label":"Den gesamten Dialog anzeigen ({nrOfMgs} Einträge)"},"fr":{"switch-label":"Afficher l’intégralité du dialogue ({nrOfMgs} entrées)"},"it":{"switch-label":"Mostra l\u0027intera finestra di dialogo (voci {nrOfMgs})"}}')
  delete Component.options._Ctor
}
